// extracted by css-extract-rspack-plugin
export default {"upload-statement":"upload-statement-4TcCzw","uploadStatement":"upload-statement-4TcCzw"};